import { render, staticRenderFns } from "./Event.vue?vue&type=template&id=d904de9a&scoped=true&"
import script from "./Event.vue?vue&type=script&lang=js&"
export * from "./Event.vue?vue&type=script&lang=js&"
import style0 from "./Event.vue?vue&type=style&index=0&id=d904de9a&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d904de9a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d904de9a')) {
      api.createRecord('d904de9a', component.options)
    } else {
      api.reload('d904de9a', component.options)
    }
    module.hot.accept("./Event.vue?vue&type=template&id=d904de9a&scoped=true&", function () {
      api.rerender('d904de9a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/Activity/SensorEvents/Event.vue"
export default component.exports